const raw = process.env.REACT_APP_API_BASE || '';
/** Trim trailing slash so `${API_BASE}/api/...` always resolves cleanly. */
const API_BASE = typeof raw === 'string' ? raw.replace(/\/+$/, '') : '';
export default API_BASE;
